import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface EventListRowSkeletonProps {
  className?: string;
}

export function EventListRowSkeleton({ className }: EventListRowSkeletonProps) {
  return (
    <Card
      className={cn(
        'w-full flex-row gap-0 overflow-hidden rounded-2xl border border-card-border py-0',
        className,
      )}
    >
      <div className="relative aspect-video w-[45%] shrink-0 self-center sm:self-start">
        <Skeleton className="absolute inset-0 rounded-none" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-2 p-4">
        <Skeleton className="h-5 w-20 rounded-full" />
        <Skeleton className="h-5 w-4/5" />
        <Skeleton className="h-3.5 w-2/5" />
        <Skeleton className="h-3 w-2/3" />
        <div className="flex flex-1 items-end pt-1">
          <Skeleton className="h-10.5 w-full rounded-lg" />
        </div>
      </div>
    </Card>
  );
}
